export var VariableStateEnum;
(function (VariableStateEnum) {
    VariableStateEnum[VariableStateEnum["Normal"] = 0] = "Normal";
    VariableStateEnum[VariableStateEnum["Offline"] = 1] = "Offline";
    VariableStateEnum[VariableStateEnum["Unbind"] = 3] = "Unbind";
    VariableStateEnum[VariableStateEnum["DataNormal"] = 9] = "DataNormal";
    VariableStateEnum[VariableStateEnum["Abnormal"] = 99] = "Abnormal";
})(VariableStateEnum || (VariableStateEnum = {}));
